import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token fallback (for environments where cookies don't propagate)
const TK_KEY = "moon_session_token";
export const setToken = (t) => {
  if (t) localStorage.setItem(TK_KEY, t);
  else localStorage.removeItem(TK_KEY);
};
export const getToken = () => localStorage.getItem(TK_KEY);

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
